import { Rule } from '../rule.js';
import * as Definitions from '../methods/definitions.js';
export default Definitions.all
    .map((def) => 'title' in def
    ? Rule({
        details: {
            id: def.name,
            slug: def.name,
            title: def.title,
            description: def.description,
            isInternal: true
        },
        props: {
            type: def.type
        },
        type: 'collection'
    })
    : null)
    .filter(Boolean);
//# sourceMappingURL=elements.js.map